import { useController, useFormContext } from 'react-hook-form'

import { FocusTarget } from '@/components/form/focus-target'
import { NumericInput, NumericInputProps } from '@/components/ui/numeric-input'

interface NumericInputFormFieldProps
  extends Omit<NumericInputProps, 'value' | 'onChange' | 'error'> {
  name: string
}

export const NumericInputFormField = ({
  name,
  maxLength,
  ...props
}: NumericInputFormFieldProps) => {
  const { field, fieldState } = useController({ name })
  const { clearErrors, trigger } = useFormContext()

  const handleChange = (value: string) => {
    field.onChange(value)
    if (!value) clearErrors(name)
    // Character limit is validated out-of-scope of the onTouched flow: show the
    // error immediately on overflow instead of capping the native input.
    else if (maxLength && value.length > maxLength) trigger(name)
  }

  return (
    <FocusTarget fieldRef={field.ref}>
      <NumericInput
        {...props}
        name={field.name}
        value={field.value != null ? String(field.value) : ''}
        error={fieldState.error?.message}
        onBlur={field.onBlur}
        onChange={handleChange}
      />
    </FocusTarget>
  )
}
